import { SmartImportPageGroupActionEnum, SmartImportStatementStatusEnum } from "../enum/solo-enum";

export interface SmartImportTransaction {
  uniqueRowId: number;
  pageNumber: number;
  cardNumber: string;
  expenseDate: string;
  amount: string;
  referenceNumber: string;
  supplier: string;
  currency: string;
  amountConfidence: number;
  isSuspectAmount: boolean;
  verifiedAmount?: string;
  wasCorrected: boolean;
}

export interface SmartImportPageGroup {
  id: number;
  groupOrder: number;
  pageNumbers: number[];
  pageCount: number;
  fingerprint: string;
  contentTypeLabel: string;
  descriptionText: string;
  confidence: number;
  aiRecommendation: SmartImportPageGroupActionEnum;
  action: SmartImportPageGroupActionEnum | null;
  viewed: boolean;
  rememberRule: boolean;
  transactions: SmartImportTransaction[];
}

export interface SmartImportAnalysisResponse {
  statementId: number;
  status: SmartImportStatementStatusEnum;
  fileName: string;
  fileUrl?: string;
  totalPages: number;
  isFileAlreadyImported: boolean;
  cardImportOriginalFileId?: number;
  importDateTime?: string;
  transactionsImported?: number;
  hasNoTransactions: boolean;
  pageGroups: SmartImportPageGroup[];
}

export interface SmartImportGroupClassification {
  groupId: number;
  action: SmartImportPageGroupActionEnum;
  remember: boolean;
}

export interface SmartImportAmountCorrection {
  groupId: number;
  uniqueRowId: number;
  verifiedAmount: string;
}

export interface ClassifySmartImportStatementRequest {
  statementId: number;
  classifications: SmartImportGroupClassification[];
  amountCorrections: SmartImportAmountCorrection[];
}

export interface SmartImportRule {
  fingerprint: string;
  action: SmartImportPageGroupActionEnum;
  contentTypeLabel: string;
}

export interface SmartImportRuleListResponse {
  rules: SmartImportRule[];
}

/**
 * Ordering per spec §6.2: page count descending (largest group first), ties broken
 * by confidence descending, then by first occurrence (lowest first page number).
 */
export function sortSmartImportPageGroups(groups: SmartImportPageGroup[]): SmartImportPageGroup[] {
  return [...groups].sort((a, b) => {
    if (b.pageCount !== a.pageCount) return b.pageCount - a.pageCount;
    if (b.confidence !== a.confidence) return b.confidence - a.confidence;
    return (a.pageNumbers[0] ?? 0) - (b.pageNumbers[0] ?? 0);
  });
}
